import React, { useEffect, useRef } from 'react';
import 'asciinema-player/dist/bundle/asciinema-player.css';

interface AsciinemaPlayerProps {
  src: string;
  cols?: number;
  rows?: number;
  autoPlay?: boolean;
  preload?: boolean;
  loop?: boolean | number;
  startAt?: number | string;
  speed?: number;
  idleTimeLimit?: number;
  theme?: string;
  poster?: string;
  fit?: 'width' | 'height' | 'both' | 'none';
  terminalFontSize?: string;
  terminalFontFamily?: string;
  terminalLineHeight?: number;
}

const AsciinemaPlayer: React.FC<AsciinemaPlayerProps> = ({
  src,
  cols = 80,
  rows = 24,
  autoPlay = false,
  preload = false,
  loop = false,
  startAt = 0,
  speed = 1,
  idleTimeLimit = 2,
  theme = 'asciinema',
  poster,
  fit = 'width',
  terminalFontSize = 'small',
  terminalFontFamily = 'monospace',
  terminalLineHeight = 1.33333333,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const loadPlayer = async () => {
      if (ref.current) {
        const AsciinemaPlayerLibrary = await import('asciinema-player');

        AsciinemaPlayerLibrary.create(src, ref.current, {
          cols,
          rows,
          autoPlay,
          preload,
          loop,
          startAt,
          speed,
          idleTimeLimit,
          theme,
          poster,
          fit,
          terminalFontSize,
          terminalFontFamily,
          terminalLineHeight,
        });
      }
    };

    loadPlayer();
  }, [
    src,
    cols,
    rows,
    autoPlay,
    preload,
    loop,
    startAt,
    speed,
    idleTimeLimit,
    theme,
    poster,
    fit,
    terminalFontSize,
    terminalFontFamily,
    terminalLineHeight,
  ]);

  return <div ref={ref} />;
};

export default AsciinemaPlayer;
